import React, { useState, useMemo } from "react";
import { withRouter } from "react-router-dom";
import queries from "../helpers/queries";
import { useForm, Controller } from "react-hook-form";
import { withUser } from "../Contexts/user";
import Table from "../Components/darkBasicTable";
import { useQuery } from "@apollo/react-hooks";
import useDimensions from "../Hooks/useDimensions";
import Select from "react-select";
import _ from "lodash";
import { addBackList, removeBackList } from "../redux/userRedux";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import excel from "../Components/excel";

const capitalizeWords = (str) => {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

const statusOptions = [
    {
        label: "All",
        value: "all",
    },
    {
        label: "Active",
        value: "active",
    },
    {
        label: "Suspended",
        value: "suspended",
    },
    {
        label: "Risk Suspended",
        value: "risksuspended",
    },
];

const rankings = [
    {
        label: "All",
        value: "all",
    },
    {
        label: "Prime Leader",
        value: "5ec264312bde7cefbf119c4c",
    },
    {
        label: "Leader",
        value: "5ec2676c877421f075d0cbff",
    },
    {
        label: "Agent",
        value: "5ec5f937dfa89a2ccea9e9d9",
    },
];

const Teams = withRouter(() => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const size = useDimensions();
    const [seniorPrimeLeaderCount, setSeniorPrimeLeaderCount] = useState(0);
    const [primeLeaderCount, setPrimeLeaderCount] = useState(0);
    const [leaderCount, setLeaderCount] = useState(0);

    const {
        handleSubmit: handleFilterSubmit,
        reset,
        control,
        errors,
    } = useForm({
        defaultValues: {
            name: "",
            referral: null,
        },
    });

    const filterSelectStyles = useMemo(
        () => ({
            control: (provided, state) => ({
                ...provided,
                borderColor: errors.area ? "#fc8181" : "#e2e8f0",
                backgroundColor: "#fbfdfe",
                borderRadius: "0.5rem",
                padding: "0.20rem",
                "&:hover": {
                    borderColor: errors.area ? "#fc8181" : "#e2e8f0",
                },
            }),

            placeholder: (provided, state) => ({
                ...provided,
                color: "#a0aec0",
                fontSize: "0.75rem",
                fontWeight: "600",
            }),

            container: (provided, state) => ({
                ...provided,
                color: "#64748b",
                fontSize: "0.75rem",
                fontWeight: "600",
                width: "100%",
            }),
        }),
        [errors]
    );

    const [filters, setFilters] = useState({
        name: "",
        referral: "",
        status: "active",
        rankings: "all",
    });

    const [selectedAgentName, setSelectedAgentName] = useState("");

    const updateFilters = (values) => {
        setFilters((prev) => ({
            ...prev,
            ...values,
            name: values.name !== "" ? values.name.id : filters.name,
            referral:
                values.referral !== null
                    ? values.referral.id
                    : filters.referral,
            status:
                values.status !== undefined
                    ? values.status.value
                    : filters.status,
            rankings:
                values.rankings !== undefined
                    ? values.rankings.value
                    : filters.rankings,
        }));

        setPaginationState((prev) => ({ ...prev, page: 1 }));
    };

    const columns = useMemo(() => {
        const NumberFormatter = new Intl.NumberFormat("en-GB", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        if (size.width > 650) {
            return [
                {
                    Header: "Name",
                    accessor: "name",
                    Cell: ({ row: { original } }) => (
                        <div className="capitalize">
                            {original.nickname != "-"
                                ? `${capitalizeWords(original.nickname)} `
                                : ""}
                            {capitalizeWords(original.name)}
                        </div>
                    ),
                },
                {
                    Header: "Ranking",
                    accessor: "progression",
                    Cell: ({ value }) => (
                        <div className="capitalize">{value}</div>
                    ),
                },
                {
                    Header: "Date of Birth",
                    accessor: "dob",
                    Cell: ({ value }) => {
                        if (value) {
                            return (
                                <div className="capitalize">
                                    {" "}
                                    {moment(value, "x").format("DD-MM-YYYY")}
                                </div>
                            );
                        }

                        return <div>-</div>;
                    },
                },
                {
                    Header: "Personal Sales",
                    accessor: "personalSales",
                    Cell: ({ value }) => (
                        <div>{NumberFormatter.format(value)}</div>
                    ),
                },
                {
                    Header: "Group Sales",
                    accessor: "groupSales",
                    Cell: ({ value }) => (
                        <div>{NumberFormatter.format(value)}</div>
                    ),
                },
                {
                    Header: "Upline",
                    id: "uplines",
                    Cell: ({ row: { original } }) => (
                        <div className="flex flex-col gap-1">
                            {original.referral && (
                                <div className="capitalize">
                                    {original.referral.nickname &&
                                    original.referral.nickname !== "-"
                                        ? `${capitalizeWords(
                                              original.referral.nickname
                                          )} `
                                        : ""}
                                    {original.referral.name &&
                                        capitalizeWords(original.referral.name)}
                                </div>
                            )}
                            {original.secondReferral && (
                                <div className="capitalize">
                                    {original.secondReferral.nickname &&
                                    original.secondReferral.nickname !== "-"
                                        ? `${capitalizeWords(
                                              original.secondReferral.nickname
                                          )} `
                                        : ""}
                                    {original.secondReferral.name &&
                                        capitalizeWords(
                                            original.secondReferral.name
                                        )}
                                </div>
                            )}
                        </div>
                    ),
                },
                {
                    Header: "Status",
                    id: "memberStatus",
                    Cell: ({ row: { original } }) => {
                        if (original.status === "risksuspended") {
                            return <div>Risk Suspend</div>;
                        }
                        if (original.status === "suspended") {
                            return <div>Suspend</div>;
                        }
                        if (original.status === "active") {
                            switch (original.risk) {
                                case "clear":
                                    return <div>Active</div>;
                                case "lv1":
                                    return <div>1 Week No Case</div>;
                                case "lv2":
                                    return <div>2 Weeks No Case</div>;
                                case "lv3":
                                    return <div>3 Weeks No Case</div>;
                                case "lv4":
                                    return <div>1 Month No Case</div>;
                                case "lv5":
                                    return <div>2 Months No Case</div>;
                                case "lv6":
                                    return <div>3 Months No Case</div>;
                                default:
                                    return <div>Active</div>;
                            }
                        }
                        return <div>{original.status}</div>;
                    },
                },
                // {
                //     Header: "Find Downline",
                //     id: "actions",
                //     Cell: ({ row: { original } }) => {
                //         return (
                //             <div className="flex items-center justify-center">
                //                 <div
                //                     className="cursor-pointer mr-2"
                //                     onClick={async () => {
                //                         dispatch(
                //                             addBackList(
                //                                 filters.referral
                //                                     ? filters.referral
                //                                     : ""
                //                             )
                //                         );
                //                         setFilters((prev) => ({
                //                             ...prev,
                //                             referral: original._id,
                //                         }));

                //                         setPaginationState((prev) => ({
                //                             ...prev,
                //                             page: 1,
                //                         }));
                //                     }}
                //                 >
                //                     <FcSupport />
                //                 </div>
                //             </div>
                //         );
                //     },
                // },
            ];
        } else {
            return [
                {
                    Header: "Name",
                    accessor: "name",
                    Cell: ({ row: { original } }) => (
                        <div className="capitalize">
                            {original.nickname != "-"
                                ? `${capitalizeWords(original.nickname)} `
                                : ""}
                            {capitalizeWords(original.name)}
                        </div>
                    ),
                },
                {
                    Header: "Personal Sales",
                    accessor: "personalSales",
                    Cell: ({ value }) => (
                        <div>{NumberFormatter.format(value)}</div>
                    ),
                },
                {
                    Header: "Group Sales",
                    accessor: "groupSales",
                    Cell: ({ value }) => (
                        <div>{NumberFormatter.format(value)}</div>
                    ),
                },
            ];
        }
    }, [size, filters.referral, dispatch]);

    const [paginationState, setPaginationState] = useState({
        limit: 9999,
        page: 1,
    });

    const { loading: downlinesLoading, data: downlinesData } = useQuery(
        queries.FETCH_DOWNLINES,
        {
            variables: {
                limit: paginationState.limit,
                page: paginationState.page,
                referral: filters.name,
                status: filters.status.value,
                rank: filters.rankings.value || "all",
            },
            fetchPolicy: "network-only",
            onCompleted: ({ fetchDownlines }) => {
                alert("Team Loading is Completed");
                setPaginationState(fetchDownlines.pagination);

                // Count members by progression
                let seniorPrimeCount = 0;
                let primeCount = 0;
                let leaderCount = 0;

                fetchDownlines.data.forEach((member) => {
                    if (member.progression === "seniorleader") {
                        seniorPrimeCount++;
                    } else if (member.progression === "primeleader") {
                        primeCount++;
                    } else if (member.progression === "leader") {
                        leaderCount++;
                    }
                });

                setSeniorPrimeLeaderCount(seniorPrimeCount);
                setPrimeLeaderCount(primeCount);
                setLeaderCount(leaderCount);
            },
        }
    );

    const getMemberCounts = (data) => {
        if (!data)
            return {
                total: 0,
                seniorPrimeLeader: 0,
                primeLeader: 0,
                leader: 0,
            };

        const counts = {
            total: data.pagination.documents || 0,
            seniorPrimeLeader: 0,
            primeLeader: 0,
            leader: 0,
        };

        data.data.forEach((member) => {
            switch (member.progression) {
                case "Senior Prime Leader":
                    counts.seniorPrimeLeader++;
                    break;
                case "Prime Leader":
                    counts.primeLeader++;
                    break;
                case "Leader":
                    counts.leader++;
                    break;
                default:
                    break;
            }
        });

        return counts;
    };

    return (
        <div className="team-container lg:flex">
            <div className="w-full team-card">
                <h1 className="team-title">TEAMS</h1>
                <div className="team-counts">
                    <div className="team-count-item total">
                        <span className="label">Team Members</span>
                        <span className="value">
                            {downlinesData?.fetchDownlines?.data.length || 0}
                        </span>
                    </div>
                    <div className="team-count-item prime">
                        <span className="label">Prime Leader</span>
                        <span className="value">{primeLeaderCount}</span>
                    </div>
                    <div className="team-count-item senior-prime">
                        <span className="label">Senior Leader</span>
                        <span className="value">{seniorPrimeLeaderCount}</span>
                    </div>

                    <div className="team-count-item leader">
                        <span className="label">Leader</span>
                        <span className="value">{leaderCount}</span>
                    </div>
                </div>

                {/* Agent Selection Indicator */}
                {filters.name && (
                    <div className="agent-selection-banner">
                        <div className="banner-content">
                            <div className="banner-text">
                                <div className="banner-title">
                                    Viewing Agent's Downline
                                </div>
                                <div className="agent-name">
                                    {(() => {
                                        // First priority: use stored agent name
                                        if (selectedAgentName) {
                                            return selectedAgentName;
                                        }

                                        // Second priority: try to find from uplineFilterList
                                        const selectedAgent =
                                            downlinesData?.fetchDownlines?.uplineFilterList?.find(
                                                (agent) =>
                                                    agent.id === filters.name
                                            );

                                        if (selectedAgent) {
                                            return selectedAgent.label;
                                        }

                                        // Third priority: try to find in the data array
                                        const agentFromData =
                                            downlinesData?.fetchDownlines?.data?.find(
                                                (agent) =>
                                                    agent._id === filters.name
                                            );

                                        if (agentFromData) {
                                            return `${
                                                agentFromData.nickname &&
                                                agentFromData.nickname !== "-"
                                                    ? capitalizeWords(
                                                          agentFromData.nickname
                                                      ) + " "
                                                    : ""
                                            }${capitalizeWords(
                                                agentFromData.name
                                            )}`;
                                        }

                                        // Final fallback - show a more user-friendly message
                                        return "Agent Selected";
                                    })()}
                                </div>
                            </div>
                            <button
                                className="clear-agent-btn"
                                onClick={() => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        name: "",
                                    }));
                                    setSelectedAgentName("");
                                }}
                                title="Clear agent selection"
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                )}

                <div className="team-filters">
                    <div className="filter-group">
                        <Select
                            styles={filterSelectStyles}
                            placeholder="Agent"
                            value={filters.name}
                            onChange={(value) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    name: value?.id || "",
                                }));
                                setSelectedAgentName(value?.label || "");
                            }}
                            options={
                                downlinesData?.fetchDownlines
                                    .uplineFilterList || []
                            }
                        />

                        <Select
                            styles={filterSelectStyles}
                            placeholder="Ranking"
                            value={filters.rankings}
                            onChange={(value) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    rankings: value,
                                }))
                            }
                            options={rankings}
                        />
                        <Select
                            styles={filterSelectStyles}
                            placeholder="Status"
                            value={filters.status}
                            onChange={(value) =>
                                setFilters((prev) => ({
                                    ...prev,
                                    status: value,
                                }))
                            }
                            options={statusOptions}
                        />
                        <button
                            className="team-search-btn"
                            onClick={() => {
                                let payload = [];

                                if (
                                    downlinesData &&
                                    downlinesData.fetchDownlines.data
                                ) {
                                    downlinesData.fetchDownlines.data.forEach(
                                        (user) => {
                                            payload.push({
                                                Name: `${
                                                    user.nickname &&
                                                    user.nickname !== "-"
                                                        ? `${capitalizeWords(
                                                              user.nickname
                                                          )} `
                                                        : ``
                                                }${capitalizeWords(user.name)}`,
                                                Ranking: user.progression,
                                                DateOfBirth: user.dob
                                                    ? moment(
                                                          user.dob,
                                                          "x"
                                                      ).format("DD-MM-YYYY")
                                                    : "",
                                                PersonalSales:
                                                    user.personalSales,
                                                GroupSales: user.groupSales,
                                                Upline: `${
                                                    user.referral?.nickname &&
                                                    user.referral?.nickname !==
                                                        "-"
                                                        ? `${capitalizeWords(
                                                              user.referral
                                                                  ?.nickname
                                                          )} `
                                                        : ``
                                                }${capitalizeWords(
                                                    user.referral?.name
                                                )}`,
                                                SecondUpline: `${
                                                    user.secondReferral
                                                        ?.nickname &&
                                                    user.secondReferral
                                                        ?.nickname !== "-"
                                                        ? `${capitalizeWords(
                                                              user
                                                                  .secondReferral
                                                                  ?.nickname
                                                          )} `
                                                        : ``
                                                }${capitalizeWords(
                                                    user.secondReferral?.name
                                                )}`,
                                                Status:
                                                    user.status ===
                                                    "risksuspended"
                                                        ? "Risk Suspend"
                                                        : user.status ===
                                                          "suspended"
                                                        ? "Suspend"
                                                        : user.status ===
                                                          "active"
                                                        ? user.risk === "clear"
                                                            ? "Active"
                                                            : user.risk ===
                                                              "lv1"
                                                            ? "1 Week No Case"
                                                            : user.risk ===
                                                              "lv2"
                                                            ? "2 Weeks No Case"
                                                            : user.risk ===
                                                              "lv3"
                                                            ? "3 Weeks No Case"
                                                            : user.risk ===
                                                              "lv4"
                                                            ? "1 Month No Case"
                                                            : user.risk ===
                                                              "lv5"
                                                            ? "2 Months No Case"
                                                            : user.risk ===
                                                              "lv6"
                                                            ? "3 Months No Case"
                                                            : "Active"
                                                        : user.status,
                                            });
                                        }
                                    );
                                }

                                excel({
                                    excelData: payload,
                                    fileName: `Teams-${
                                        new Date().toISOString().split("T")[0]
                                    }`,
                                });
                            }}
                        >
                            Export
                        </button>
                    </div>
                </div>

                <div className="team-table-container">
                    <div className="team-status-legend">
                        <div className="legend-item risk-suspend">
                            <span className="dot"></span>
                            <span>Risk Suspend</span>
                        </div>
                        <div className="legend-item suspended">
                            <span className="dot"></span>
                            <span>Suspended</span>
                        </div>
                    </div>
                    <Table
                        columns={columns}
                        data={
                            downlinesData
                                ? downlinesData.fetchDownlines.data
                                : []
                        }
                        updatePagination={setPaginationState}
                        loading={downlinesLoading}
                        pageCount={
                            downlinesData
                                ? downlinesData.fetchDownlines.pagination
                                      .totalPages
                                : 0
                        }
                        totalCount={
                            downlinesData
                                ? downlinesData.fetchDownlines.pagination
                                      .documents
                                : 0
                        }
                    />
                </div>
            </div>
        </div>
    );
});

export default withUser(Teams);
